import React from 'react';
//import { AxiosProvider, Request, Get, Delete, Head, Post, Put, Patch, withAxios } from 'react-axios';
import axios from 'axios';
import ScrollAnimation from 'react-animate-on-scroll';

import Image from '../components/ImageShift';

import map from "../assets/images/map.jpg";

const contactParameters = {
	url: "https://www.web2alpes.com/api/mail.php",
	
	pattern : {
		name: "[a-zA-ZàâæçéèêëîïôœùûüÿÀÂÆÇnÉÈÊËÎÏÔŒÙÛÜŸ\s-]+",
		email: "[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([_\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})",
		mailOrPhone: "(([A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([_\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,}))|(^0[1-7][0-9]{8}$))",
		message: "[a-zA-ZàâæçéèêëîïôœùûüÿÀÂÆÇnÉÈÊËÎÏÔŒÙÛÜŸ\s-]+",
		captcha: "[0-9]+"
	}
}

class Contact extends React.Component {

    constructor(props) {
        super(props);
		this.state = {
			captcha : {},
			selectOption: 'message',
			disabled: true,
			getCaptcha: false,
			sendState: false,
			sendError : false,
			returnMessage: "",
			getloading: false,
			submitloading: false,
			validMessage: false
		}
		this.config = contactParameters;
		this.getCaptcha = this.getCaptcha.bind(this);
		this.reset = this.reset.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSelectChange = this.handleSelectChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
    }

	componentDidMount() {
		this.getCaptcha();
		this.refs.name.addEventListener('onmouseover', event => {
  			this.handleClick();	
			console.log("clickName");
		});
  	}

	reset(){
		this.setState({
			disabled: true,
			getCaptcha: false,
            sendState: false,
            sendError : false,
            returnMessage: "",
            getloading: false,
            submitloading: false,
			validMessage: false,
			selectOption:'message'});

		this.getCaptcha();
	}

	getCaptcha(){
		const object = this;
		this.setState({getloading:true});
		axios.get(this.config.url)
            .then(res => {
				object.setState({captcha: res.data,getCaptcha:true,getloading:false});
      		})
			.catch(function (error) {
				object.setState({getCaptcha:false,getloading:false});
  			});
	}

	handleClick(e){
		if(e) e.preventDefault();
		if(this.state.getCaptcha){
			this.setState({disabled:false});
		}
	}
	//text area message validation
	handleChange(e){
		if(e) e.preventDefault();
		this.setState({validMessage: this.refs.message && this.refs.message.value && this.refs.message.value.length > 0 ? true : false});
	}

	handleSelectChange(e){
		if(e) e.preventDefault();
		this.setState({selectOption: this.refs.name && this.refs.name.value ? this.refs.name.value : 'message', disabled:false});
	}

	handleSubmit(e) {
		if(e) e.preventDefault();
		this.setState({sendError:false,sendState:false,submitloading:true});
		const object = this;
		if(this.refs.name.value == ''){
			
		}
		axios.post(this.config.url, {
    		name : this.refs.name.value,
			email: this.refs.email.value,
			captcha: this.refs.captcha.value,
			message: this.refs.name && this.refs.name.value == 'message' ? this.refs.message.value : 'A rappeler'
  		})
  		.then(function (response) {
			object.setState({returnMessage:response.data,submitloading:false});
			switch(response.data.code) {
				case 7:
					document.getElementById("contact-form").reset();
					object.getCaptcha();
					object.setState({sendState:true,disabled:true});
					break;
				default:
					object.setState({sendError:true});
			}
  		})
  		.catch(function (error) {
			console.log(error);
			object.setState({sendError:true,submitloading:false});
 		 });
	}	

 	render(){

	const captcha = this.state.captcha.x !== undefined ? this.state.captcha.x+" + "+this.state.captcha.y : "";
	const { disabled, getCaptcha, sendError, sendState, getloading, submitloading, returnMessage, validMessage } = this.state;
	const showRequired = getCaptcha && !disabled;
	const colorClass = (!getCaptcha && !getloading) || sendError ? "banner-style3" : "banner-style4";
	//<div className="field half first">
    //                    <label htmlFor="name">Vous souhaitez : { showRequired &&  <i className="icon fa-exclamation-triangle stretch"></i>}</label>
    //                    <input type="text" name="name" id="name" ref="name" pattern={this.config.pattern.name} readOnly={!getCaptcha || disabled} onClick={this.handleClick} required />
    //                </div>
	
	return (
    <section id="contact">
        <div className="inner">
            <section className="form-section">
				<ScrollAnimation animateIn="fadeIn">
				<header>
            		<h2><span className="icon alt fa-envelope"></span> Contactez moi</h2>
        		</header>
				</ScrollAnimation>
				<p>Vous avez envie de discuter d’un projet ? Parlons-en simplement autour d’un café ! Je pourrai vous faire un devis gratuit !</p>
                <form id="contact-form" method="post" onSubmit={this.handleSubmit}>
                    <div className="field half first">
                        <label htmlFor="name">Vous souhaitez :</label>
						<select id="monselect" name="name" ref="name"  onChange={this.handleSelectChange}>
  							<option selected value="message">ENVOYER UN MESSAGE</option> 
  							<option value="rappel">ETRE RECONTACTE</option>
						</select>
                    </div>
                    <div className="field half">
					<label htmlFor="email">Email ou Téléphone : { showRequired &&  <i className="icon fa-exclamation-triangle stretch"></i>}</label>
                        <input type="text" name="email" id="email" ref="email" pattern={this.config.pattern.mailOrPhone} readOnly={!getCaptcha || disabled} onClick={this.handleClick} required />
                    </div>
                    { this.state.selectOption == 'message' &&  <div className="field">
                        <label htmlFor="message">Message : { showRequired &&  <i className="icon fa-exclamation-triangle stretch"></i>}</label>
                        <textarea className={ getCaptcha && !disabled && validMessage ? "green" : getCaptcha && !disabled && !validMessage ? "red" : ""} onChange={this.handleChange} name="message" id="message" ref="message" rows="6" readOnly={!getCaptcha || disabled} onClick={this.handleClick} required></textarea>
                    </div>}
					<div className="field half first">
						<label htmlFor="calc">Combien fait :</label>
						<input type="text" id="calc" value={captcha} disabled />
                    </div>
                    <div className="field half">
                        <label htmlFor="captcha">Résultat : { showRequired &&  <i className="icon fa-exclamation-triangle stretch"></i>}</label>
                        <input type="text" name="captcha" id="captcha" pattern={this.config.pattern.captcha} ref="captcha" readOnly={!getCaptcha || disabled} onClick={this.handleClick} required />
                    </div>
                    <ul className="actions">
                        <li><button type="submit" disabled={disabled} className="special">Envoyer { submitloading && getCaptcha &&  <i className="icon fa-gear fa-spin"></i>}{ sendState &&  <i className="icon fa-check stretch"></i>} { sendError &&  <i className="icon fa-exclamation-triangle stretch"></i>}</button></li>
                        <li><button type="reset" onClick={this.reset}>Réinitialiser { getloading &&  <i className="icon fa-gear fa-spin"></i>}{ !getCaptcha && !getloading && <i className="icon fa-exclamation-triangle stretch"></i>}</button></li>
                    </ul>
                </form>
				{ ((!getCaptcha && !getloading && !submitloading ) || sendError || (returnMessage && !submitloading)) && <div className={colorClass}>
                        { !getCaptcha && !getloading && <span>Le formulaire est désactivé en raison d'un problème réseau. Cliquez sur le bouton réinitialiser ou essayez avec une autre navigateur.</span>}
                        { sendError && <span>Erreur lors de l'envoi du message</span>}
                        { returnMessage && returnMessage.reason && <span>: {returnMessage.reason}</span>}
              	</div>}
            </section>
            <section className="split">
                <section>
                    <div className="contact-method">
                        <span className="icon alt fa-phone"></span>
                        <h3>Telephone</h3>
                        <a href="tel:+33618114496" title="téléphone web2alpes">+33 (0)6.18.11.44.96</a>
                    </div>
                </section>
                <section>
                    <div className="contact-method">
                        <span className="icon alt fa-home"></span>
                        <h3>Adresse</h3>
						Rue du Rouchas<br />
                        38860 Les Deux Alpes<br />
                        France
                    </div>
                </section>
				<section>
					<div className="contact-method">
						<span className="icon alt fa-search"></span>
						<h3>Localisation</h3>
					</div>
					<ScrollAnimation animateIn="fadeIn" className="image fit">
                    	<Image src={map} alt="Localisation web2alpes" className="zoom" />
                    </ScrollAnimation>
				</section>
            </section>
        </div>
    </section>
	)}
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact.js